import $axios from '../api.js'

const state = () => ({
    intro: localStorage.getItem('introduction') ? JSON.parse(localStorage.getItem('introduction')).intro : true,
    data : localStorage.getItem('last_section') ? localStorage.getItem('last_section') : ''
})

const mutations = {
    //MEMASUKKAN DATA KE STATE INTRO
    ASSIGN_DATA(state, payload) {
        state.intro = payload.intro;
        localStorage.setItem('introduction', JSON.stringify(state))
    },
}

const actions = {
    //FUNGSI INI UNTUK MELAKUKAN REQUEST DATA QUESTIONS DARI SERVER
    getIntro({ commit, state }, payload) {
        return new Promise((resolve, reject) => {
            //REQUEST DATA DENGAN ENDPOINT /OUTLETS

            $axios.get(`/questions?lang=en&type=0`)
                .then((response) => {
                    //SIMPAN DATA KE STATE MELALUI MUTATIONS
                    let data = {
                        intro: response.data.instruction
                    };
                    commit('ASSIGN_DATA', data)
                    resolve(response.data.data)
                })
        })
    },
    getData({ commit, state }, payload) {
        return new Promise((resolve, reject) => {
            //REQUEST DATA DENGAN ENDPOINT /OUTLETS

            $axios.get(`/get-data`)
                .then((response) => {
                    //SIMPAN DATA KE STATE MELALUI MUTATIONS
                    let data = {
                        intro: response.data.instruction
                    };
                    resolve(response.data.data)
                })
        })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
